import { DispatchType } from "@bridgesplit/react";
import {
    BORDER_RADIUS,
    Column,
    IconButton,
    INPUT_HEIGHT,
    PopoverWrapper,
    Row,
    Text,
    TextButton,
    Tooltip,
    usePopover
} from "@bridgesplit/ui";
import { TuneOutlined, Visibility, VisibilityOff } from "@mui/icons-material";

// Column show/hide popover for tables with a fixed set of named columns
export function TableFilter<T extends string>({
    visibleColumns,
    allColumns,
    resetColumns,
    requiredColumns,
    maxColumns,
    setVisibleColumns
}: {
    visibleColumns: T[];
    allColumns: T[];
    resetColumns: T[];
    requiredColumns: T[];
    maxColumns: number;
    setVisibleColumns: DispatchType<T[]>;
}) {
    const { open, popoverProps } = usePopover();
    return (
        <>
            <Tooltip title="Adjust columns">
                <IconButton
                    textVariant="body2"
                    border={true}
                    jsxIcon={<TuneOutlined />}
                    onClick={open}
                    sx={{
                        opacity: "0.5",
                        borderRadius: BORDER_RADIUS,
                        height: INPUT_HEIGHT + "px",
                        width: INPUT_HEIGHT + "px"
                    }}
                />
            </Tooltip>
            <PopoverWrapper
                anchorOrigin={{ vertical: "center", horizontal: "right" }}
                transformOrigin={{ vertical: "center", horizontal: "left" }}
                {...popoverProps}
            >
                <Column p={1} spacing={1}>
                    {Object.values(allColumns)
                        .filter((t) => !requiredColumns.includes(t))
                        .map((term, i) => {
                            const isSelected = visibleColumns.includes(term);
                            return (
                                <Row spacing={2} spaceBetween key={`${term}-${i}`}>
                                    <Text variant="body2">{term}</Text>
                                    <IconButton
                                        textVariant="body2"
                                        onClick={() => {
                                            setVisibleColumns((prev) => {
                                                const copy = [...prev];
                                                if (copy.includes(term)) {
                                                    return copy.filter((c) => c !== term);
                                                }
                                                return [...copy.slice(0, maxColumns - 1), term];
                                            });
                                        }}
                                        jsxIcon={isSelected ? <VisibilityOff /> : <Visibility />}
                                        border={false}
                                    />
                                </Row>
                            );
                        })}
                    <TextButton color="caption" variant="body2" onClick={() => setVisibleColumns(resetColumns)}>
                        Reset
                    </TextButton>
                </Column>
            </PopoverWrapper>
        </>
    );
}
